import { CartService } from './../../services/cart/cart.service';
import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MResa, MSession, MUser } from '@argalis-apps/models';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { AuthService } from '../../../auth/services/auth/auth.service';
import * as moment from 'moment';

@Component({
  selector: 'ags-one-cart',
  templateUrl: './one-cart.component.html',
  styleUrls: ['./one-cart.component.scss']
})
export class OneCartComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() resa: MResa.IResa;
  @Input() userConnected: MUser.CUser = null;
  @Output() displayPopup = new EventEmitter<boolean>();
  @Output() remove = new EventEmitter<MResa.IResa>();
  public disabled = false;
  public parcoursSelect = null;
  popup = true;

  constructor(
    private router: Router,
    private cartConfigService: CartConfigService,
    private authService: AuthService,
    private cartService: CartService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${cartConfigService.themingClassName}`;
  }

  ngOnInit() {}

  public getComboLineTemplate(dataItem: MSession.ISessionInfo, resa: MResa.IResa): string {
    if (!dataItem || !resa) return 'Choisir une date';
    return `du ${moment(dataItem.debut).format('DD/MM/YYYY')} au ${moment(dataItem.fin).format(
      'DD/MM/2019'
    )} à ${dataItem.site[0].ville || dataItem.site[0].libelle} - ${resa.price}€ (${
      dataItem.places
    } places disponibles)`;
  }

  public orderValidation(resa: MResa.IResa) {
    if (!this.userConnected) {
      this.displayPopup.emit(this.popup);
    } else {
      // save resa state ? (@DB)
      this.router.navigate(['/', this.cartConfigService.routingBaseUri, 'order', resa.id]);
    }
  }

  public removeResa() {
    this.remove.emit(this.resa);
  }

  public saveSelection(resa) {
    this.cartService.selectionSession(resa.selected_session);
  }
}
